import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NoEngineeringProfessional() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [professionals, setProfessionals] = useState({});

  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  useEffect(() => {
    const fetchProfessionals = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/numberprofessionals/${memberId}`
        );
        setProfessionals(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchProfessionals();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">No. Engineering Professionals Details</h1>
        <Link to={'/edit-professional/' + memberId}>
          <button className="memberAddButton">Edit</button>
        </Link>
      </div>
      <div className="memberContainer">
        <div className="memberShow">
          <div className="memberShowBottom">
            <div className="memberShowInfo">
              <span className="memberShowInfoLabel">Name:</span>{' '}
              <span className="memberShowInfoTitle">
                {professionals.professionals}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
